import {AppAbFlag} from '@amplify/athena-models';

const flags: AppAbFlag[] = [
    {flagName: 'digicertLogo', probabilityTrue: 0},
    {flagName: 'conditionalCoverageBullet', probabilityTrue: 0},
    {
        flagName: 'conditionalCoverageLanguage1',
        categories: {
            original: 1,
        },
    },
    {flagName: 'landingPageUrgency', probabilityTrue: 0},
    {
        flagName: 'landingPageCta',
        categories: {
            Complete: 0,
            Continue: 1,
        },
    },
    {flagName: 'anchorProgressBar', probabilityTrue: 1},
    {flagName: 'autoDefaultPages', probabilityTrue: 0},
    {flagName: 'onePageRx', probabilityTrue: 1},
    {flagName: 'cookieBanner', probabilityTrue: 1},
    {flagName: 'defaultBirthStateToZip', probabilityTrue: 0},
    {flagName: 'useQueueLogging', probabilityTrue: 0.2},
    {flagName: 'financialSuitability', probabilityTrue: 1},
    {flagName: 'rxAfterSubmit', probabilityTrue: 1},
    {flagName: 'hideProviderShowNationalLifeOnly', probabilityTrue: 1},
    {flagName: 'rxExperience', probabilityTrue: 1},
    {flagName: 'upsellExperience', probabilityTrue: 1},
    {flagName: 'hideProvider', probabilityTrue: 1},
    {flagName: 'reviewScreen', probabilityTrue: 1},
    {flagName: 'CP_ALITHEIA_QUESTION_FLOW', probabilityTrue: 0},
    {flagName: 'stickyCTA', probabilityTrue: 1},
    {flagName: 'address4620', probabilityTrue: 0},
    {flagName: 'bankingOrder4633', probabilityTrue: 1},
];
export default flags;
